// extracted by mini-css-extract-plugin
export default {"section":"Home_section__LZ7Ip","home_scroll":"Home_home_scroll__WS8WJ"};